/**
 * EmptyState — consistent zero-data placeholder.
 * Text + small Lucide icon only. No illustrations.
 *
 * Usage:
 *   <EmptyState icon={Receipt} title="No sales yet" detail="Make your first sale to see it here." action="New Sale" onAction={() => {}} />
 */

export function EmptyState({
  icon: Icon,
  title,
  detail,
  action,
  onAction,
  className = '',
}) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 text-center px-4 ${className}`}>
      {Icon && (
        <span
          className="inline-flex items-center justify-center w-12 h-12 rounded-xl mb-4"
          style={{ backgroundColor: 'var(--neutral-bg)' }}
        >
          <Icon size={22} style={{ color: 'var(--neutral-icon)' }} strokeWidth={1.5} />
        </span>
      )}

      <div
        className="text-[15px] font-semibold mb-1"
        style={{ fontFamily: 'Manrope, sans-serif', color: 'var(--text-primary)' }}
      >
        {title}
      </div>

      {detail && (
        <p className="text-[13px] max-w-xs" style={{ color: 'var(--text-tertiary)' }}>
          {detail}
        </p>
      )}

      {action && (
        <button
          onClick={onAction}
          className="mt-4 px-4 h-9 rounded-md text-[13px] font-semibold transition-colors"
          style={{
            backgroundColor: 'var(--brand-primary)',
            color: '#FFFFFF',
            transitionDuration: 'var(--ease-fast)',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--brand-primary-hover)')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--brand-primary)')}
        >
          {action}
        </button>
      )}
    </div>
  );
}
